export default {
  hasOtherActiveTabs(state) {
    return Object.keys(state.otherTabs).length > 0;
  },
  showMultipleTabWarning(state, getters) {
    return getters.hasOtherActiveTabs && !state.warningDismissed;
  }
};
